import { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { changeLanguage } from '../Slices/LangSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

const LANGUAGE_KEY = 'lang';
const DEFAULT_LANG = 'en';
const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'fr', label: 'Français' },
];

const LANGUAGE_NAMES = {
  en: 'english',
  fr: 'français',
};

export function LanguageSwitcher() {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);
  const location = useLocation(); // <-- re-renders on route change

  const { language } = useSelector((state) => state.language);
  const dispatch = useDispatch();

  console.log(language,'language---------------------------')

  const toggleDropdown = () => {
    setOpen((prev) => !prev);
  };

  const handleLanguageSelect = (code) => {
    dispatch(changeLanguage(code));
    setOpen(false);
  };

  useEffect(() => {
    if (!open) return;

    const handleDocumentClick = () => {
      setOpen(false);
    };

    document.addEventListener("click", handleDocumentClick);
    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, [open]);

  const pathname = location.pathname; // <-- now always current
  const show =
    pathname === "/pack" ||
    pathname === "/subscribe" ||
    pathname === "/otp" ||
    pathname === "/confirm" ||
    pathname.startsWith("/pack/");

  if (!show) {
    return null;
  }

  return (
    <div style={containerStyle} ref={containerRef}>
      <button
        type="button"
        style={pillButtonStyle}
        onClick={(e) => {
          e.stopPropagation();
          toggleDropdown();
        }}
        aria-expanded={open}
        aria-label="Change language"
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "scale(1.05)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "scale(1)";
        }}
      >
        {LANGUAGE_NAMES[language] || language}
      </button>
      {open && (
        <div style={dropdownStyle} onClick={(e) => e.stopPropagation()}>
          {LANGUAGES.map((lang) => (
            <button
              key={lang.code}
              type="button"
              onClick={() => handleLanguageSelect(lang.code)}
              style={
                language === lang.code
                  ? activeLanguageStyle
                  : languageOptionStyle
              }
              onMouseEnter={(e) => {
                if (language !== lang.code) {
                  e.currentTarget.style.background = "#f5f3ff";
                }
              }}
              onMouseLeave={(e) => {
                if (language !== lang.code) {
                  e.currentTarget.style.background = "transparent";
                }
              }}
            >
              {lang.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

const containerStyle = {
  position: "fixed",
  top: "20px",
  right: "20px",
  zIndex: 9999,
};

const pillButtonStyle = {
  padding: "10px 22px",
  borderRadius: "999px",
  border: "none",
  background: "linear-gradient(90deg, #f97316, #ef4444)",
  color: "#fff",
  fontSize: "14px",
  fontWeight: "600",
  cursor: "pointer",
  boxShadow: "0 8px 24px rgba(239, 68, 68, 0.35)",
  transition: "all 0.25s ease",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textTransform: "lowercase",
};

const dropdownStyle = {
  position: "absolute",
  top: "56px",
  right: 0,
  background: "#fff",
  borderRadius: "16px",
  padding: "8px",
  minWidth: "180px",
  boxShadow: "0 12px 35px rgba(0,0,0,0.14)",
  display: "flex",
  flexDirection: "column",
  gap: "6px",
  border: "1px solid #f3f4f6",
  animation: "fadeIn 0.2s ease",
};

const languageOptionStyle = {
  padding: "12px 14px",
  border: "none",
  borderRadius: "10px",
  background: "transparent",
  cursor: "pointer",
  textAlign: "left",
  fontSize: "14px",
  fontWeight: "500",
  color: "#374151",
  transition: "all 0.2s ease",
};

const activeLanguageStyle = {
  ...languageOptionStyle,
  background: "linear-gradient(90deg, #f97316, #ef4444)",
  color: "#fff",
};